export default function disablePasswordProtectionReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'DISABLE_PASSWORD-PROTECTION_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'DISABLE_PASSWORD-PROTECTION_ERROR':
            return {...state, ...{error: action.error}};

        case 'DISABLE_PASSWORD-PROTECTION_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}